import { render, staticRenderFns } from "./shipinheji.vue?vue&type=template&id=ad45cbdc&scoped=true&"
import script from "./shipinheji.vue?vue&type=script&lang=js&"
export * from "./shipinheji.vue?vue&type=script&lang=js&"
import style0 from "./shipinheji.vue?vue&type=style&index=0&id=ad45cbdc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad45cbdc",
  null
  
)

export default component.exports